module.exports = __webpack_public_path__ + "065ff3fc565824c5bb33269820d33c8f.svg";